import { jsx as _jsx } from "react/jsx-runtime";
import { AddToAnotherClientModal } from '~/components/AddToAnotherClientModal/AddToAnotherClientModal';
import { EditContactModal } from '~/components/EditContactModal/EditContactModal';
export const editContactModalConfig = (param)=>{
    let { contact, clientId } = param;
    return {
        biName: 'edit_contact_modal',
        closeOnEscapeKey: true,
        closeOnClickOutside: true,
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(EditContactModal, {
                clientId: clientId,
                contact: contact,
                lockedClientName: contact.companyName(),
                dismissModal: dismissModal
            });
        }
    };
};
export const addToAnotherClientModalConfig = (param)=>{
    let { contact, contacts } = param;
    return {
        biName: 'add_to_another_client_modal',
        closeOnEscapeKey: true,
        closeOnClickOutside: true,
        content: (param)=>{
            let { dismissModal } = param;
            return /*#__PURE__*/ _jsx(AddToAnotherClientModal, {
                contact: contact,
                contacts: [
                    ...contacts
                ],
                dismissModal: dismissModal
            });
        }
    };
};
